import { ComputedStaticTextInput } from '@framework/form';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../inputs';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { ExpressionValue } from '../../../../expressions/evaluate/ExpressionValue';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { formatComputedNumberValue } from '../../computed/number/computedNumberFormatter';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ISwitchWidget } from './ISwitchWidget';
import { useSwitchExpressionValue } from './useSwitchExpressionValue';

const InputBorder = styled.div`
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 10px;
`;

function customRenderFormat(value: any, datatype: Datatype): string {
  // In caso di date, renderizziamo con il formato DD/MM/YYYY
  // per simulare un campo data.
  if (
    datatype === Datatype.Date &&
    typeof value === 'string' &&
    Boolean(value)
  ) {
    return dayjs(value, 'YYYY-MM-DD').format('DD/MM/YYYY').toString();
  }

  // Per i numeri, formattiamo con la virgola.
  if (datatype === Datatype.Number) {
    return formatComputedNumberValue(value);
  }

  return value?.toString() ?? '';
}

export interface IScoreWidgetComponentProps
  extends IWidgetComponentProps<ISwitchWidget> {}

export function SwitchWidgetComponent(props: IScoreWidgetComponentProps) {
  const { widget } = props;
  const options = getWidgetProps(props);

  const value = useSwitchExpressionValue(options.name, widget.expression);

  const renderFormat = useCallback(
    (v: ExpressionValue) => customRenderFormat(v, widget.datatype),
    [widget.datatype],
  );

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <ComputedStaticTextInput
        name={options.name}
        value={value}
        removeBorder={widget.layout?.removeBorder}
        readonly={options.readonly}
        renderFormat={renderFormat}
      />
    </ConfigFormItem>
  );
}
